import { render, staticRenderFns } from "./PopupContainer.vue?vue&type=template&id=00aa0d58&"
import script from "./PopupContainer.vue?vue&type=script&lang=js&"
export * from "./PopupContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports